export class EvalancheForm {
  private instance: HTMLElement;
  private form: HTMLFormElement;
  private requiredFields: NodeListOf<HTMLElement>;
  private validationFields: NodeListOf<HTMLElement>;

  constructor(instance) {
    this.instance = instance;
    this.form = this.instance.querySelector('.tx-evalanche-form');
    this.requiredFields = this.form.querySelectorAll('[required]');
    this.validationFields = this.form.querySelectorAll('[data-validate]');

    this.initShowButton();
    this.requiredHandler();
    this.submitHandler();
  }

  submitHandler() {
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (this.validationFields.length > 0) {
        if (!this.isFormValid()) {
          this.scrollToFormStart();
          return false;
        }
      }

      this.sendForm();
    })
  }

  requiredHandler() {
    if (this.requiredFields.length > 0) {
      this.requiredFields.forEach(field => {
        field.addEventListener('invalid', (event) => {
          this.hideValidationError(field);
          if (!this.isFieldFilled(field)) {
            this.showValidationError(field);
          }
        });
        field.addEventListener('change', (event) => {
          this.hideValidationError(field);
        });
      });
    }
  }

  isFormValid() {
    let state = true;

    if (this.validationFields.length > 0) {
      this.validationFields.forEach(field => {
        this.hideValidationError(field);
        if (!this.isFieldValid(field)) {
          this.showValidationError(field);
          state = false;
        }
      });
    }

    return state;
  }

  isFieldValid(field) {
    let state = true;

    switch (field.dataset.validate) {
      case 'email':
        state = this.emailValidator(field.value);
        break;
      default:
        // not defined case is valid
        state = true;
        break;
    }

    return state
  }

  isFieldFilled(field) {
    let state = true;

    if (field.required) {
      switch (field.type) {
        case 'checkbox':
        case 'radio':
          state = field.checked;
          break;
        default:
          state = field.value !== '';
          break;
      }
    }

    return state;
  }

  emailValidator(string) {
    return /^(.+)@(.+)\.(.+)$/.test(string);
  }

  hideValidationError(field) {
    if (field.type === 'checkbox' || field.type === 'radio') {
      field.parentElement.querySelector('span').classList.remove('tx-evalanche-form__invalid-field');
    } else {
      if (field.classList.contains('tx-evalanche-form__invalid-field')) {
        field.classList.remove('tx-evalanche-form__invalid-field');
        let errorMessage = field.parentElement.querySelector('.tx-evalanche-form__validation-error');
        if (errorMessage) {
          errorMessage.remove();
        }
      }
    }
  }

  showValidationError(field) {
    if (field.type === 'checkbox' || field.type === 'radio') {
      field.parentElement.querySelector('span').classList.add('tx-evalanche-form__invalid-field');
    } else {
      if (field.dataset.validateError) {
        let errorMessage = document.createElement('p');
        errorMessage.innerHTML = field.dataset.validateError;
        errorMessage.classList.add('tx-evalanche-form__validation-error');
        field.after(errorMessage);
      }

      field.classList.add('tx-evalanche-form__invalid-field');
    }
  }

  scrollToFormStart() {
    location.href = '#' + this.form.id;
  }

  sendForm() {
    this.form.classList.add('tx-evalanche-form--sending');

    fetch(this.form.action, {
      method: 'POST',
      body: new FormData(this.form)
    }).then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const contentType = response.headers.get('content-type');
      if (!contentType || contentType.indexOf('application/json') === -1) {
        throw new Error('Response is not valid JSON');
      }
      return response.json();
    }).then(data => {
      if (data.success === true) {
        const parentElement: HTMLElement = this.form.parentElement.querySelector('.tx-evalanche-form__success');
        if (parentElement) {
          parentElement.style.display = 'block';
        }
        this.form.remove();
      } else {
        const parentElement: HTMLElement = this.form.parentElement.querySelector('.tx-evalanche-form__error');
        if (parentElement) {
          parentElement.style.display = 'block';
        }
      }
      this.scrollToInstance();
    }).catch(error => {
      this.form.classList.remove('tx-evalanche-form--sending');
      const errorElement: HTMLElement = this.form.parentElement.querySelector('.tx-evalanche-form__error');
      if (errorElement) {
        errorElement.style.display = 'block';
      }
    });
  }

  initShowButton() {
    let button: HTMLElement = this.instance.querySelector('.tx-evalanche-form-show-button');
    if (button) {
      button.addEventListener('click', () => {
        this.form.style.display = 'block';
        button.style.display = 'none';
      });
    }
  }

  scrollToInstance() {
    const y = this.instance.getBoundingClientRect().top + window.scrollY;
    window.scroll(0, y);
  }
}

let forms = document.querySelectorAll('.tx-evalanche-forms__instance');
if (forms.length > 0) {
  forms.forEach(form => {
    new EvalancheForm(form);
  });
}
